import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterItem } from '@/api/model/interfaces';

export default class RegisterItemOdata extends OdataManager<RegisterItem> {}
